import type { NextPage } from 'next';
import _ from 'lodash';
import { db } from 'data';
import { CopitosDeNieve, SkiStation } from '../../data/schema';
import { readItems } from '@directus/sdk';
import { getStaticPropsNicho } from 'ui';
import { StationCard } from '../../components/stations/station-card';

type Props = {
	stations: SkiStation[];
};

const Brands: NextPage<Props> = ({ stations }) => {
	return (
		<div className="container">
			<div>
				<h1 className="text-3xl dark:text-gray-200">
					Estaciones de esqui indoor, outdoor, de montaña y alpinas.
				</h1>
				<h2 className="text-xl	dark:text-gray-200">
					A continuación te mostramos todas las estaciones de esqui para que te lo pases pipa.
				</h2>
			</div>
			<div className="flex flex-wrap justify-center">
				{stations.map((station: SkiStation) => {
					return <StationCard station={station} key={station.code} />;
				})}
			</div>
		</div>
	);
};

export const getStaticProps = getStaticPropsNicho(async () => {
	const cms = db<CopitosDeNieve>();
	const stations = await cms.request(readItems('cn_ski_stations', { sort: 'name' }));

	return {
		props: {
			stations,
			title: 'Estaciones de esqui'
		}
	};
});

export default Brands;
